//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import {
  ExclamationPoint,
  lifelineIconUrl,
  flagIconUrl,
  purchasesIconUrl,
} from '@cmp/images';
//------------------------------------------------------------------------------
// API -------------------------------------------------------------------------
import { Providers as ProvidersRequest } from '@api/endpoints/get/providers';
//------------------------------------------------------------------------------
// Helpers & Constants ---------------------------------------------------------
import { StoreConfigContext } from '@helpers/storeConfigContext';
import { withAuthUser } from '@helpers/auth';
import { currencyFormatter } from '@helpers/formatter';
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Overview extends React.Component {
  itemComponent(title, value, className) {
    const componentClasses = classNames(styles.Item, {
      [className]: className,
    });

    return (
      <div className={componentClasses}>
        <div className={styles.Header}>
          <span className={styles.Title}>{title}</span>
        </div>
        <span className={styles.Value}>{value}</span>
      </div>
    );
  }

  render() {
    const {
      className,
      balance = '0',
      totalEarnings = '0',
      recommendationCount = '0',
      purchaseCount = '0',
      t,
      i18n,
    } = this.props;
    const componentClasses = classNames(styles.History, {
      [className]: className,
    });

    const {
      storeConfig: { currencySymbol, language },
    } = this.context;

    const DASHBOARD_DISCLAIMER_T_KEY = 'dashboard_Disclaimer';
    const disclaimerKeyValue = t(DASHBOARD_DISCLAIMER_T_KEY);
    const disclaimerText =
      disclaimerKeyValue !== DASHBOARD_DISCLAIMER_T_KEY
        ? disclaimerKeyValue
        : '';

    return (
      <div>
        <div className={componentClasses}>
          {this.itemComponent(
            t('dashboard_Balance'),
            currencyFormatter.priceWithCurrency(
              balance,
              currencySymbol,
              language
            ),
            lifelineIconUrl(i18n),
            styles.Balance
          )}
          {this.itemComponent(
            t('dashboard_TotalEarnings'),
            currencyFormatter.priceWithCurrency(
              totalEarnings,
              currencySymbol,
              language
            ),
            lifelineIconUrl(i18n),
            styles.TotalEarnings
          )}
          {this.itemComponent(
            t('dashboard_Recommendations'),
            recommendationCount,
            flagIconUrl(i18n),
            styles.Recommendations
          )}
          {this.itemComponent(
            t('dashboard_Purchases'),
            purchaseCount,
            purchasesIconUrl(i18n),
            styles.Purchases
          )}
        </div>
        {disclaimerText && (
          <div className={styles.History}>
            <div className={styles.DisclaimerContainer}>
              <div className={styles.IconContainer}>
                <ExclamationPoint />
              </div>
              <p className={styles.DisclaimerText}>{disclaimerText}</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withAuthUser(withTranslation()(Overview));

Overview.contextType = StoreConfigContext;
